export default __webpack_public_path__ + "static/media/BRN.a6353437.svg";